export const pointerHeight = 12;
export const pointerWidth = 18;
